
    var riot = require('riot')
    //src: starling/src/tags/site-previewer-item.html
riot.tag2('site-previewer-item',
  '<div class="site-previewer" ref="main" if="{isNotHidden()}"> <header class="site-previewer_header"> <a href="{url}" target="_blank" onclick="{panToLink}" rel="noopener noreferrer" class="site-previewer_link"> <img class="site-previewer_favicon" alt="Plectica" riot-src="/favicons/{opts.canvas.config.env}/favicon.ico"> <h3 class="site-previewer_title">{title}</h3> <svg class="site-previewer_arrow"> <use xlink:href="#arrow-top-right"></use> </svg> </a> <button class="site-previewer_menu floating-menu_button" onclick="{toggleMenu}" ondblclick="{ignoreDblClick}"> <svg class="floating-menu_button_icon"> <use xlink:href="#more-vert-icon"></use> </svg> </button> </header> <a href="{url}" onclick="{panToLink}" target="_blank" rel="noopener noreferrer" class="site-previewer_link"> <img if="{!isCollapsed()}" class="site-previewer_image" riot-src="{thumbnail_image_url || preview_image_url || \'/share-image.png\'}" onload="{handleImageLoad}" alt="{title}"> </a> </div>',
  '',
  'class="site-previewer_item"', function(opts) {
'use strict';

var _this = this;

var _sitePreviewUi = require('lib/site-preview-ui');

var _nodesUi = require('lib/nodes-ui');

var _sharedUtil = require('lib/shared-util');

var _opts = opts,
    canvas = _opts.canvas,
    nodeTag = _opts.nodetag;
var config = canvas.config,
    access = canvas.access;
var sitePreviewerMenu = canvas.sitePreviewerMenu;

this.toggleMenu = function (e) {
  var item = e.item,
      currentTarget = e.currentTarget;

  e.preventDefault();

  if (sitePreviewerMenu.isOpen) {
    sitePreviewerMenu.hide();
  } else {
    sitePreviewerMenu.summon({
      referenceEl: _this.refs.main,
      nodeTag: nodeTag,
      data: item
    });
  }
};

this.ignoreDblClick = function (e) {
  e.stopPropagation();
  e.preventDefault();
};

this.isNotHidden = function () {
  return !_sitePreviewUi.spUI.getLinkIsHidden({
    nodeId: nodeTag.id,
    url: _this.url
  });
};

this.isCollapsed = function (e) {
  return _sitePreviewUi.spUI.getLinkIsCollapsed({
    nodeId: nodeTag.id,
    url: _this.url
  });
};

this.handleImageLoad = function (e) {
  var _nui$fixOverlaps = _nodesUi.nui.fixOverlaps({
    nodeTag: nodeTag,
    fromExpand: true,
    fromCollapse: false,
    allowedDirections: ['right', 'left', 'down']
  }),
      prevNodePositions = _nui$fixOverlaps.prevNodePositions,
      nodePositions = _nui$fixOverlaps.nodePositions;

  if (nodePositions.length) {
    canvas.operation.updateNodePositions({
      prevNodePositions: prevNodePositions,
      nodePositions: nodePositions,
      prevLinkAngles: [],
      linkAngles: []
    });
  }
};

this.panToLink = function (e) {
  if (!(0, _sharedUtil.isUrlInternal)({
    config: config,
    access: access,
    url: _this.url
  })) return;

  e.preventDefault();

  var _ref = new URL(_this.url),
      searchParams = _ref.searchParams;

  var nodes = searchParams.get('nodeid');
  var regions = searchParams.get('regionId');

  var nodeIds = nodes ? nodes.split(',') : [];
  var regionIds = regions ? regions.split(',') : [];

  var centeringNodes = store.filterNodes(function (_ref2) {
    var id = _ref2.id;
    return nodeIds.includes(id);
  });
  var centeringRegions = regionIds.filter(function (id) {
    return store.getRegion(id);
  }).map(function (id) {
    return { id: id };
  });

  if (centeringNodes.length || centeringRegions.length) {
    canvas.centerContent({
      nodes: centeringNodes,
      regions: centeringRegions
    }, { animate: true });

    canvas.setSelectedElements(centeringNodes.map(function (_ref3) {
      var id = _ref3.id;
      return canvas.nodeTags[id];
    }));
  }
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('site-previewer-item')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/site-previewer-item.html
// module id = 749
// module chunks = 0